// Amazon locker (ONCA project): nature J on a French parcelshop.
// Single place to adapt if the criterion changes (e.g. nature M with no country condition).
export const AMAZON_LOCKER_NATURE = "J";
export const AMAZON_LOCKER_COUNTRY = "FR";

export function isAmazonLocker(parcelshop) {
  return (
    !!parcelshop &&
    parcelshop.CodeNature === AMAZON_LOCKER_NATURE &&
    parcelshop.Adresse?.Pays?.Code === AMAZON_LOCKER_COUNTRY
  );
}

// A locker is a classic locker (nature C) or an Amazon locker (nature J in France).
export const LOCKER_NATURE = "C";

// Natures that make a tariff or a parcelshop a locker for a given country: C, plus J in France.
export function getLockerNatures(countryCode) {
  return String(countryCode || "").toUpperCase() === AMAZON_LOCKER_COUNTRY
    ? [LOCKER_NATURE, AMAZON_LOCKER_NATURE]
    : [LOCKER_NATURE];
}

export function isLocker(parcelshop) {
  return (
    !!parcelshop &&
    (parcelshop.CodeNature === LOCKER_NATURE || isAmazonLocker(parcelshop))
  );
}
